/**
 * Labstep
 */

import React from 'react';
import type { EntitySearchContextType } from './types';

export const defaultEntitySearchContext = {
  sortOptions: undefined,
  usePostFilter: false,
};

export const EntitySearchContext =
  React.createContext<EntitySearchContextType>(
    defaultEntitySearchContext,
  );
